import React, { useState } from "react";
import reportNames from "../../assets/static/reports.json";
import { Grid, MenuItem, TextField } from "@mui/material";
import TopLinks from "../../components/TopLinks/TopLinks";
import "./Reports.css";
import ApplicationStatusReport from "./ApplicationStatusReport";

const Reports = () => {
  const [reportName, setReportName] = useState(reportNames[0]);

  const topLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "Reports",
      isCurrent: true,
    },
  ];

  //builders
  const BuildReportViews = () => {
    return (
      <div className="mt-10">
        {(() => {
          switch (reportName) {
            case "Applications Status Report":
              return <ApplicationStatusReport />;
            default:
              return <></>;
          }
        })()}
      </div>
    );
  };
  return (
    <>
      <TopLinks links={topLinks} />

      <Grid container>
        <Grid item xs={12} sm={6} md={3} className="padded-grid-item">
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="dense"
            name="Status"
            id="Status"
            select
            label="Status"
            onChange={(event) => {
              if (event.target.value) {
                setReportName(event?.target?.value);
              }
            }}
            value={reportName || null}
          >
            {reportNames?.map((option, index) => {
              return (
                <MenuItem key={`report=${index}`} value={option}>
                  {option}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
      </Grid>
      {BuildReportViews()}
    </>
  );
};

export default Reports;
